import { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

import RoleMiddleware from '@/components/RoleMiddleware.jsx'
const AdmissionDashboard = lazy(() =>
    import('@/deprecated/Admission/Dashboard/index.jsx')
)
const KQEvaluation = lazy(() =>
    import('@/deprecated/Admission/BackOffice/KQEvaluation/index.jsx')
)
const SimilarCandidates = lazy(() =>
    import(
        '@/deprecated/Admission/BackOffice/KQEvaluation/SimilarCandidates/index.jsx'
    )
)
import AdmissionClientLogin from '@/deprecated/Admission/Client/Login/index.jsx'
import AdmissionClientRegister from '@/deprecated/Admission/Client/Register/index.jsx'
const AdmissionClient = lazy(() => import('@/deprecated/Admission/Client/index.jsx'))
const AdmissionClientLayout = lazy(() =>
    import('@/deprecated/Admission/Client/_layout.jsx')
)
const AdmissionBackOfficeLayout = lazy(() =>
    import('@/deprecated/Admission/BackOffice/_layout.jsx')
)
const AdmissionBackOffice = lazy(() =>
    import('@/deprecated/Admission/BackOffice/index')
)
const AdmVoucherManagement = lazy(() =>
    import('@/deprecated/Admission/BackOffice/VoucherManagement/index')
)

const AdmChallengeInstructions = lazy(() =>
    import('@/deprecated/Admission/Challenge/Instructions')
)
const Admission = lazy(() => import('@/deprecated/Admission/index'))

const AdmissionRouter = (
    <Routes>
        <Route index element={<Admission />} />
        <Route
            exact
            path={'challenge/:axSlug'}
            element={<AdmChallengeInstructions />}
        />
        <Route path={'dashboard'} element={<AdmissionDashboard />} />
        <Route
            path="back-office"
            element={
                <RoleMiddleware
                    roles={[
                        'kq_voucher_manager',
                        'kq_admin',
                        'kq_evaluator',
                        'kq_manager',
                    ]}
                >
                    <AdmissionBackOfficeLayout />
                </RoleMiddleware>
            }
        >
            <Route index element={<AdmissionBackOffice />} />
            <Route
                path="voucher-management"
                element={
                    <RoleMiddleware roles={['kq_voucher_manager']}>
                        <AdmVoucherManagement />
                    </RoleMiddleware>
                }
            />
            <Route
                path="kq-evaluation"
                element={
                    <RoleMiddleware
                        roles={['kq_admin', 'kq_evaluator', 'kq_manager']}
                    >
                        <KQEvaluation />
                    </RoleMiddleware>
                }
            />
            <Route
                path="kq-evaluation/similar-candidates"
                element={
                    <RoleMiddleware
                        roles={['kq_admin', 'kq_evaluator', 'kq_manager']}
                    >
                        <SimilarCandidates />
                    </RoleMiddleware>
                }
            />
        </Route>
        <Route path={':clientSlug'} element={<AdmissionClientLayout />}>
            <Route index element={<AdmissionClient />} />
            <Route path={'register'} element={<AdmissionClientRegister />} />
            <Route path={'login'} element={<AdmissionClientLogin />} />
        </Route>
    </Routes>
)

export default AdmissionRouter
